import { SET_BOOKMARK_DISCARD } from './constants';

export const setBookmarkDiscard = discard => dispatch => {
  dispatch({
    type: SET_BOOKMARK_DISCARD,
    payload: discard,
  });
};
